export default  {
    component: 'rpi_list',
    name: 'rpi_list',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true
          },
          {
            name: 'Inverter Room',
            param: 'inverter_room',
            type: 'number',
            required: true,
            identifier: true
          },
          {
            name: 'RPI ID',
            param: 'rpi_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `ETiLog name should be added`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `If the etilogs is more than 1 for 1 block, device id should increment and it should start from 1.`
          },
          {
            name: 'Component',
            param: 'component',
            type: 'text',
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          }
    ]
  }




